app.controller('startController', function(
    $scope,
    $state,
    $q,
    objectService
) {
    $scope.isLoading = true
    $scope.toggleStatusGroup = 1
    $scope.dateIsTooLate = false

    function isDateTooLate(configuration) {
        // Add 24 hours so end date is inclusive
        var endDate = new Date(new Date(configuration.data.end_date).getTime() + 24*60*60*1000)
        var now     = new Date();

        return endDate.getTime() < now.getTime()
    }

    $scope.getTemplate = function() {
        var object = objectService.getObject()
        switch(true){
            case object.status == STATUS.NEW:
                return 'partials/start/not_open.html'
            case object.status == STATUS.EARLY_CHOICES_PENDING:
                return 'partials/start/early_choices.html'
            case object.status == STATUS.EARLY_CHOICES_SIGNING || object.status == STATUS.EARLY_CHOICES_COMPLETE:
                return 'partials/start/early_choices_done.html'
            case object.status == STATUS.DESIGN_CHOICES_PENDING:
                return 'partials/start/design_choices.html'
            case object.status >= STATUS.DESIGN_CHOICES_SIGNING:
                return 'partials/start/design_choices_done.html'
            case object.status >= STATUS.COMPLETED:
                return 'partials/start/done.html'
            default:
                return 'partials/start/idle.html'
        }
    }

    objectService.fetchObject()
        .then(function() {
            $scope.object         = objectService.getObject()
            $scope.manager        = objectService.manager
            $scope.buyers         = objectService.buyers
            $scope.configuration  = objectService.getCurrentConfiguration()
            $scope.configurations = $scope.object.configurations
            $scope.isLoading      = false

            $scope.hasEarlyChoices = objectService.hasEarlyChoices()
            $scope.hasDesignChoices = objectService.hasDesignChoices()

            if($scope.configuration){
                $scope.dateIsTooLate = isDateTooLate($scope.configuration)
            }
        })
});
